import { Box, Typography, createStyles, makeStyles, Theme, Grid, Button } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    padding: {
      padding: theme.spacing(2),
    },
    button: {
      marginTop: 6,
      marginLeft: 12,
    },
  }),
);

interface ConfirmDeleteProps {
  handleCancel: () => void;
  handleDelete: () => void;
}

const ConfirmDelete: React.FC<ConfirmDeleteProps> = props => {
  const classes = useStyles();
  const { handleCancel, handleDelete } = props;
  return (
    <Box>
      <Grid container className={classes.padding}>
        <Grid item xs={12} lg={12}>
          <Typography variant="h6">Delete this payment method?</Typography>
        </Grid>
      </Grid>
      <Grid container justify="flex-end" className={classes.padding}>
        <Button className={classes.button} color="primary" onClick={handleCancel} data-cy="cancel">
          CANCEL
        </Button>
        <Button className={classes.button} variant="contained" color="primary" onClick={handleDelete} data-cy="delete">
          DELETE
        </Button>
      </Grid>
    </Box>
  );
};

export default ConfirmDelete;
